export const CONTENT_DELIVERY_PLATFORM_VALUES = [
  '微信视频号',
  '微信公众号',
  '小红书',
  '抖音',
  '快手',
];

export const CONTENT_DELIVERY_PLATFORM_OPTIONS = CONTENT_DELIVERY_PLATFORM_VALUES.map((value) => ({
  label: value,
  value,
}));

// 视频上传时的默认投递平台（仅当用户未手动选择时自动填充）
export const DEFAULT_VIDEO_DELIVERY_PLATFORMS = [...CONTENT_DELIVERY_PLATFORM_VALUES];

